import { z } from 'zod';
import { GreenhouseIntegration } from 'libs/end-to-end/src/types/databases/integrations/greenhouse-integration';
import { ShareFileIntegration } from 'libs/end-to-end/src/types/databases/integrations/sharefile-integration';
import { WorkdayIntegration } from 'libs/end-to-end/src/types/databases/integrations/workday-integration';
import { HTTPIntegration } from 'libs/end-to-end/src/types/databases/integrations/http-integration';
import { MergeIntegration } from 'libs/end-to-end/src/types/databases/integrations/merge-integration';
import { PostgresIntegration } from 'libs/end-to-end/src/types/databases/integrations/postgres-integration';
import { ADPIntegration } from 'libs/end-to-end/src/types/databases/integrations/adp-integration';
import { SnowflakeIntegration } from 'libs/end-to-end/src/types/databases/integrations/snowflake-integration';
import { PeregrineIntegration } from 'libs/end-to-end/src/types/databases/integrations/peregrine-integration';
import { SqlServerIntegration } from 'libs/end-to-end/src/types/databases/integrations/sql-server-integration';

export const Integration = z.union([
  ShareFileIntegration,
  GreenhouseIntegration,
  WorkdayIntegration,
  HTTPIntegration,
  MergeIntegration,
  PostgresIntegration,
  ADPIntegration,
  SnowflakeIntegration,
  PeregrineIntegration,
  SqlServerIntegration,
]);

export type Integration = z.infer<typeof Integration>;
